import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import DatePicker from 'react-multi-date-picker'

import SearchInput from '../../components/SearchInput'
import MuiFilterSelect from '../../components/Filters/MuiFilterSelect'
import GoogleIcon from '../../icon/GoogleIcon'
import dayjs from '../../utils/dayjsConfig'
import { DATE_PICKER_SETTINGS } from '../../delivery/constants/constants'
import {
  UI_COLOR_ACCENT_AMBER,
  UI_COLOR_PRIMARY_SOFT_ALT
} from '../../constants/uiColors'
import { buildSelectValue } from '../helpers/refundMobileFilters'
import { ASYNC_FILTER_KEYS } from '../helpers/refundIndexFilters'
import { REFUND_FILTER_KEYS } from '../constants/refundStatus'

function RefundIndexDatePicker({ selectedDates, onChange }) {
  const hasDateValue = Boolean(selectedDates?.length)

  return (
    <DatePicker
      range
      rangeHover
      dateSeparator=" - "
      months={DATE_PICKER_SETTINGS.months}
      weekDays={DATE_PICKER_SETTINGS.weekDays}
      format="DD MMM"
      weekStartDayIndex={DATE_PICKER_SETTINGS.weekStartDayIndex}
      highlightToday={false}
      numberOfMonths={2}
      maxDate={dayjs().local().endOf('day').toDate()}
      onChange={onChange}
      value={selectedDates}
      plugins={[
        <Toolbar
          key="refund-datepicker-toolbar"
          position="bottom"
          names={{
            deselect: 'Deseleccionar'
          }}
          sort={['deselect']}
        />
      ]}
      render={(value, openCalendar) => (
        <Box className="mui-filter-select" sx={{ width: '100%' }}>
          <Box
            title="Rango de fechas"
            onClick={openCalendar}
            className={`mui-filter-select__trigger ${hasDateValue ? 'mui-filter-select__trigger--open' : ''}`}
          >
            <Box className="mui-filter-select__content">
              <Box className="mui-filter-select__label-wrap">
                <Typography className="mui-filter-select__title">
                  {value?.length > 0
                    ? Array.isArray(value)
                      ? value.join(' - ')
                      : value
                    : 'RANGO DE FECHAS'}
                </Typography>
              </Box>
              <FontAwesomeIcon
                icon={faCalendar}
                style={{
                  color: hasDateValue ? UI_COLOR_ACCENT_AMBER : UI_COLOR_PRIMARY_SOFT_ALT,
                  fontSize: 16
                }}
              />
            </Box>
          </Box>
        </Box>
      )}
    />
  )
}

export default function RefundIndexDesktopFilters({
  filterConfigs,
  appliedFilterSelections,
  selectedDates,
  isAnyFilterSelected,
  searchInput,
  onFilterChange,
  onDateChange,
  onFilterSearchChange,
  onFilterLoadMore,
  onResetFilters,
  onSearchChange,
  onSearchEnter,
  onSearchClear
}) {
  return (
    <>
      <h4 className="text-sub-title-filters">Filtrar devoluciones por:</h4>

      <Box className="refunds-filters">
        <Box className="refunds-filters__group">
          <GoogleIcon className="filter-icon-poc oc-icon-primary" name="page_info" size={22} />

          {filterConfigs.map((filter) => {
            const isAsyncFilter =
              ASYNC_FILTER_KEYS.includes(filter.key) && !filter.skipAsync
            const itemClassName =
              filter.key === REFUND_FILTER_KEYS.USER
                ? 'refunds-filters__item refunds-filters__item--creado-por'
                : 'refunds-filters__item'

            return (
              <Box key={filter.key} className={itemClassName}>
                <MuiFilterSelect
                  title={filter.title}
                  options={filter.options}
                  pinnedOptions={filter.pinnedOptions || []}
                  value={appliedFilterSelections[filter.key] || buildSelectValue()}
                  onChange={(nextValue) => onFilterChange(filter.key, nextValue)}
                  disabled={Boolean(filter.disabled)}
                  width="100%"
                  dropdownWidth={320}
                  maxVisibleOptions={filter.maxVisibleOptions || 5}
                  onSearchChange={
                    isAsyncFilter
                      ? (nextSearch) => onFilterSearchChange(filter.key, nextSearch)
                      : undefined
                  }
                  onLoadMore={isAsyncFilter ? () => onFilterLoadMore(filter.key) : undefined}
                  hasMore={Boolean(filter.hasMore)}
                  loading={Boolean(filter.loading)}
                />
              </Box>
            )
          })}

          <Box className="refunds-filters__item refunds-filters__item--date">
            <RefundIndexDatePicker selectedDates={selectedDates} onChange={onDateChange} />
          </Box>

          {isAnyFilterSelected && (
            <Typography
              variant="body2"
              className="reset-filter-mui refunds-filters__reset"
              onClick={onResetFilters}
            >
              Restablecer filtros aplicados
            </Typography>
          )}
        </Box>

        <Box className="refunds-filters__search">
          <SearchInput
            value={searchInput}
            onChange={onSearchChange}
            onEnter={onSearchEnter}
            onClear={onSearchClear}
            placeholder="Buscar por # devolución, nombre..."
          />
        </Box>
      </Box>
    </>
  )
}
